import React, {useContext, useEffect, useState} from "react";
import {AppContext} from "./../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import ApiConfig from "../api/ApiConfig";
import {getWithAuthCallWithErrorResponse, simpleGetCall, simplePostCall,} from "../api/ApiServices";
import {Table} from "react-bootstrap";
import Loading from "../sharedComponents/Loaders/Loading";
import {PaginationCustomer} from "./PaginationCustomer";
import {useParams} from "react-router";
import {Link} from "react-router-dom";
import Modal from "react-bootstrap/Modal";

const ProductReview = () => {
    const {sidebar} = useContext(AppContext);
    const {id} = useParams();

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(15);
    const [numPages, setNumPages] = useState(1);
    const changePage = (page) => {
        if (page > 0 && page <= numPages) {
            setCurrentPage(page);
        }
    };

    const [productReviews, setProductReviews] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [viewShow, setViewShow] = useState(false);
    const [viewData, setViewData] = useState({});
    const handleViewClose = () => {
        setViewShow(false);
    };

    const handleViewShow = (productId) => {
        setViewShow(true);
        getProductDetails(productId);
    };

    const getProductReviewsOfProduct = (page = 1) => {
        setIsLoading(true);
        getWithAuthCallWithErrorResponse(ApiConfig.GET_PRODUCT_REVIEW_BY_ID + `${id}&page=${page}&size=${perPage}`)
            .then((res) => {
                let data = res.json;
                setIsLoading(false);
                if (data?.status && data.status === 200) {
                    setProductReviews(data.reviews || []);
                    setPerPage(data.per_page || 15);
                    setNumPages(data.num_pages || 1);
                    setCurrentPage(data.current_page || 1);
                } else {
                    setProductReviews([]);
                }
            }).catch((err) => {
            setIsLoading(false);
            console.log(err);
        });
    };

    useEffect(() => {
        getProductReviewsOfProduct(currentPage);
    }, [currentPage, id]);

    const handleStatusChange = (reviewId, newStatus) => {
        if (reviewId && newStatus) {
            changeStatusOfReview(reviewId, newStatus);
        }
    };

    const changeStatusOfReview = (reviewId, status) => {
        setIsLoading(true);
        let reqBody = JSON.stringify({
            reviewID: Number(reviewId), status: String(status)
        });

        simplePostCall(ApiConfig.APPROVE_REVIEW_STATUS, reqBody)
            .then((res) => {
                setIsLoading(false);
                if (res.success) {
                    setProductReviews((prevReviews) => {
                        return prevReviews.map((review) => {
                            if (Number(review.id) === Number(reviewId)) {
                                return {...review, status: status};
                            }
                            return review;
                        });
                    });
                }
            }).catch((err) => {
            setIsLoading(false);
            console.log(err);
        });
    }

    const getProductDetails = (productId) => {
        simpleGetCall(`${ApiConfig.VIEW_SINGLE_PRODUCT_ID + "/" + productId}`)
            .then((res) => {
                setViewData(res);
            })
            .catch((err) => {
                console.log("GET single id error", err);
            });
    };


    return (<main
        id="cx-main"
        className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
        <div className="heading-btn-main">
            <div className="heading-common">
                <label htmlFor="">PRODUCT REVIEW</label>
            </div>
        </div>


        <div className="table-wrapper">
            <div className="mb-3">
                <Link to="/Products">
                    ← Back to Products
                </Link>
            </div>
            <div className="headerFlex">
                <div className="innerLabel">
                    <label className="labelTxt">
                        Total Records : {productReviews.length}
                    </label>
                </div>
            </div>
            {isLoading ? (<Loading/>) : (<Table striped hover id="Categories" class="table display">
                <thead>
                <tr>
                    <th>Sr No.</th>
                    <th>User Name</th>
                    <th>User Email</th>
                    <th>Product Name</th>
                    <th>Rating</th>
                    <th>Comment</th>
                    <th>Status</th>
                </tr>
                </thead>
                <tbody>
                {productReviews?.length > 0 ? (productReviews.map((productReview, index) => (
                    <tr key={"productReview" + index}>
                        <td>{index + 1}</td>
                        <td>{productReview?.userName || ""}</td>
                        <td>{productReview?.userEmail || ""}</td>
                        <td>
                            <Link to="#" onClick={(e) => {
                                e.preventDefault();
                                handleViewShow(productReview.productId);
                            }}>
                                {productReview?.productName || ""}
                            </Link>
                        </td>

                        <td>{productReview?.rating || ""}</td>
                        <td>{productReview?.comment || ""}</td>
                        <td>
                            <select
                                value={productReview?.status?.toLowerCase() || "pending"}
                                onChange={(e) => handleStatusChange(productReview.id, e.target.value)}
                                className="form-control"
                                style={{
                                    backgroundColor: productReview?.status?.toLowerCase() === "pending" ? "#fff3cd" : productReview?.status?.toLowerCase() === "approved" ? "#d4edda" : "#f8d7da",
                                    color: productReview?.status?.toLowerCase() === "pending" ? "#856404" : productReview?.status?.toLowerCase() === "approved" ? "#155724" : "#721c24",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                    textAlign: "center"
                                }}>
                                {productReview?.status?.toLowerCase() === "pending" && (
                                    <option value="pending">⏳ Pending</option>)}
                                <option value="approved">✅ Approved</option>
                                <option value="rejected">❌ Rejected</option>
                            </select>
                        </td>

                    </tr>))) : (<tr>
                    <td colSpan="6" className="text-center">Records Not Found</td>
                </tr>)}
                </tbody>
            </Table>)}
            <div className="d-flex justify-content-end">
                {productReviews && productReviews.length > 0 ? (<PaginationCustomer
                    changePage={changePage}
                    pageCount={numPages}
                    currentPage={currentPage}/>) : ('')}
            </div>
        </div>

        <Modal
            show={viewShow}
            onHide={handleViewClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Header closeButton>
                <Modal.Title>PRODUCT DETAILS</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="row user-detail">
                    <div className="col-md-3 ">
                        <label htmlFor="">Name:</label>
                    </div>
                    <div className="col-md-9 ">
                        <span>{viewData.name}</span>
                    </div>
                </div>

                <div className="row user-detail">
                    <div className="col-md-3 ">
                        <label htmlFor="">Category :</label>
                    </div>
                    <div className="col-md-9 ">
                        <span>{viewData.categoryName}</span>
                    </div>
                </div>
                <div className="row user-detail">
                    <div className="col-md-3 ">
                        <label htmlFor="">Price :</label>
                    </div>
                    <div className="col-md-9 ">
                        <span>$ {viewData.price}</span>
                    </div>
                </div>
                <div className="row user-detail">
                    <div className="col-md-3 ">
                        <label htmlFor="">Description :</label>
                    </div>
                    <div className="col-md-9 ">
                        <p>{viewData.discription}</p>
                    </div>
                </div>
                <div className="row user-detail">
                    <div className="col-md-3 ">
                        <label htmlFor="">Detail(s) :</label>
                    </div>
                    <div className="col-md-9 ">
                        <p>{viewData.details}</p>
                    </div>
                </div>
                <div className="row user-detail">
                    <div className="col-md-3 ">
                        <label htmlFor="">Image(s) :</label>
                    </div>
                    <div className="col-md-9 ">
                        <div className="p-details-img">
                            {viewData?.images?.length > 0 ? (viewData.images.map((img) => {
                                return <img src={img?.img} alt=""/>;
                            })) : (<p className="text-warning">No Images Found</p>)}
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>

    </main>);
};

export default ProductReview;
